import { render, staticRenderFns } from "./EtiquetasContainer.vue?vue&type=template&id=30c9aba4&scoped=true"
import script from "./EtiquetasContainer.vue?vue&type=script&lang=js"
export * from "./EtiquetasContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c9aba4",
  null
  
)

export default component.exports